export const EmailStatusIds = {
  FAILED: "165b1106-77bb-4dc2-8bfc-63dcf463f9bd",
  OPENED: "e23e5f6d-6317-45a3-8c5b-bff67a115853",
  DELIVERED: "3fbc98f5-74fc-44dd-8d72-4eb97bade57d",
  LINK_CLICKED: "47bc3ab6-1861-4c2f-81f7-6404fe5b18a8"
};

export const EmailStatusConfig = {
  [EmailStatusIds.FAILED]: {
    label: "Failed to deliver",
    color: "#C40A0A"
  },
  [EmailStatusIds.OPENED]: {
    label: "Opened",
    color: "#03457E"
  },
  [EmailStatusIds.DELIVERED]: {
    label: "Delivered",
    color: "#0F9AD6"
  },
  [EmailStatusIds.LINK_CLICKED]: {
    label: "Link clicked",
    color: "#50C40A"
  }
};

const sampleBrokerContactName = "Marsellus Wallace";
const sampleBrokerContactEmail = "marsellus.wallace@og.com";

export const SAMPLE_EMAIL_RECIPIENT_DATA = [
  {
    companyName: "BAMF Wallets Corp",
    companyId: 11,
    contact: {
      contactName: "Jules Winnfield",
      contactEmail: "jwinnfield@bamf.com",
      brokerContactName: sampleBrokerContactName,
      brokerContactEmail: sampleBrokerContactEmail
    },
    deals: [
      {
        name: "BAMF Deal 1"
      },
      {
        name: "BAMF Deal 2"
      }
    ],
    emailStatus: EmailStatusIds.FAILED
  },
  {
    companyName: "Royale Industries",
    companyId: 25,
    contact: {
      contactName: "Vincent Vega",
      contactEmail: "vvega@royaleindustries.com",
      brokerContactName: sampleBrokerContactName,
      brokerContactEmail: sampleBrokerContactEmail
    },
    deals: [
      {
        name: "Royale with Cheese"
      }
    ],
    emailStatus: EmailStatusIds.OPENED
  },
  {
    companyName: "Compromised Boxer Inc",
    companyId: 99,
    contact: {
      contactName: "Butch Coolidge",
      contactEmail: "bcool@compromisedboxer.com",
      brokerContactName: sampleBrokerContactName,
      brokerContactEmail: sampleBrokerContactEmail
    },
    deals: [
      {
        name: "Take bribe"
      },
      {
        name: "Win boxing match"
      },
      {
        name: "Run from Marsellus"
      },
      {
        name: "Save Marsellus"
      }
    ],
    emailStatus: EmailStatusIds.DELIVERED
  },
  {
    companyName: "Twist LLC",
    companyId: 6,
    contact: {
      contactName: "Mia Wallace",
      contactEmail: "mia.wallace@twist.com",
      brokerContactName: sampleBrokerContactName,
      brokerContactEmail: sampleBrokerContactEmail
    },
    deals: [
      {
        name: "Dinner"
      },
      {
        name: "Dance the twist"
      },
      {
        name: "Health scare"
      }
    ],
    emailStatus: EmailStatusIds.LINK_CLICKED
  },
  {
    companyName: "Wolf Cleaners",
    companyId: 123,
    contact: {
      contactName: "Winston Wolf",
      contactEmail: "winston.wolf@wolfcleaners.com",
      brokerContactName: sampleBrokerContactName,
      brokerContactEmail: sampleBrokerContactEmail
    },
    deals: [
      {
        name: "Clean"
      }
    ],
    emailStatus: null
  }
];

export const ClientBrokersGroup = {
  CLIENTS: {
    name: "Clients",
    value: 0
  },
  BROKERS: {
    name: "Brokers",
    value: 1
  }
};

export const CLIENTS_BROKERS_OPTIONS = [
  { name: ClientBrokersGroup.CLIENTS.name, value: ClientBrokersGroup.CLIENTS.value },
  { name: ClientBrokersGroup.BROKERS.name, value: ClientBrokersGroup.BROKERS.value }
];
